import type { StoreApi } from 'zustand'
import type { AnalyticsClient, EnvType, FeatureFlagsStore, Logger } from '../../domain/types'
import type { RelativePastTimeResolver } from '@/intl/relativePastTimeResolver'
import type { PriceDetailsApiClient } from '@/scopes/common/infrastructure/price-details/api/types'
import type { createQueryStringClient } from '@/scopes/common/infrastructure/query-strings/queryStringClient'
import type { createUserAuthenticationClient } from '@/scopes/common/infrastructure/user'
import createDependenciesScope from '@/scopes/common/infrastructure/dependencies/createDependenciesScope'

export interface Common {
  env: EnvType
  relativePastTimeResolver: RelativePastTimeResolver
  analyticsClient: AnalyticsClient
  featureFlagsStore: StoreApi<FeatureFlagsStore>
  priceDetailsApiClient: PriceDetailsApiClient
  queryStringClient: ReturnType<typeof createQueryStringClient>
  userAuthenticationClient: ReturnType<typeof createUserAuthenticationClient>
  logger: Logger
}

const { Provider, useDependency } = createDependenciesScope<Common>()

export const CommonDependenciesProvider = Provider
export const useCommonDependency = useDependency
